export default "__VITE_ASSET__49142892__"